import React, { useState } from "react";
import { Card, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Spin } from "antd";
import toast from "react-hot-toast";
import DownloadExcelModel from "./ExcelModel";
import FileUpload from "./FileUpload";
import ExcelJS from "exceljs";
import { createUser, updateUser } from "../../../Users/services/userApi";
import { FaUsers } from "react-icons/fa6";

const AddDriverMass = ({ modal, setModal, toggle }) => {
  const [usersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleAcceptedFiles = (files) => {
    const file = files[0];

    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    });

    setSelectedFiles([file]);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(e.target.result);

      const worksheet = workbook.worksheets[0];
      const users = [];

      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber === 1) return;

        const prenomNom = row.getCell(1).value;
        const email = row.getCell(2).value;
        const phone = row.getCell(3).value;
        const address = row.getCell(4).value;
        const permis = row.getCell(5).value;

        if (!prenomNom || !email || !phone || !permis) {
          toast.error(`Ligne ${rowNumber + 1}: Veuillez remplir les champs obligatoires.`);
          return;
        }

        users.push({
          name: prenomNom,
          email: email,
          phone: phone,
          address: address,
          licenseNumber: permis,
          role:{name:"DRIVER"},
          status:"Actif",
          username:email,
          password:"Syst@link123"
        });
      });

      if (users.length === 0) {
        toast.error("Aucune donnée valide à ajouter.");
      } else {
        setUsersData(users);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const promises = usersData.map(async (user) => updateUser(user));
      await Promise.all(promises);
      toast.success("Chauffeurs ajoutés avec succès 🎉");
      setModal(false);
    } catch (error) {
      toast.error("Erreur lors de l'ajout des chauffeurs : " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop={"static"} style={{ maxWidth: "800px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        Ajout en masse des chauffeurs par un fichier excel <FaUsers />
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <DownloadExcelModel />
            </Col>
            <Col lg={6}>
              <FileUpload selectedFiles={selectedFiles} handleAcceptedFiles={handleAcceptedFiles} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
        <div className="d-flex justify-content-end gap-2 mt-3">
            <Button className="bordered-btn" color="light" onClick={() => setModal(false)}>
                Annuler
            </Button>
            <Button type="submit" className="active-tab" disabled={isLoading || usersData.length === 0}>
                {isLoading ? "Chargement..." : "Ajouter les véhicules"}
                {isLoading && <Spin />}
            </Button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AddDriverMass;
